var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('mypage-layout', {
    attrs: {
      "title": "재고현황"
    }
  }, [_c('page-section', {
    staticClass: "page-section--xs pt-0"
  }, [_c('template', {
    slot: "containerImmersive"
  }, [_c('inventory-status')], 1)], 2), _c('inventory-form', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('inventory-list', _vm._g({
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, {
    setSummary: _vm.setSummary,
    input: _vm.emit
  })), _c('page-section', {
    staticClass: "page-section--xs pb-0"
  }, [_c('template', {
    slot: "containerImmersive"
  }, [_c('inventory-foot', _vm._b({}, 'inventory-foot', {
    summary: _vm.summary
  }, false))], 1)], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }